export default {
    categories: {
        service: {
            title: window.i18n.__('Services'),
            subtitle: window.i18n.__('Données service'),
        },
    },
    rows: [
        {
            category: 'service',
            label: window.i18n.__('Identifiant service'),
            description: {
                text: window.i18n.__('Récupéré depuis un export Sellsy'),
                subtext: window.i18n.__('Utile uniquement en cas de mise à jour'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Référence'),
            description: {
                text: window.i18n.__('Référence ou code du service unique dans votre catalogue'),
            },
            mandatory: true,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Nom commercial'),
            description: {
                text: window.i18n.__('Nom du service affiché sur les documents'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Description'),
            description: {
                text: window.i18n.__('Description affichée sur les documents'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Unité'),
            description: {
                text: window.i18n.__('Unité de quantification du service'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__("Valeur de l'unité parmi la liste existante"),
            },
            valueFrom: {
                source: 'units',
                modalName: window.i18n.__('Afficher toutes les unités'),
                maxDisplay: 6,
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Quantité usuelle'),
            description: {
                text: window.i18n.__('Quantité usuelle du service'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Catégorie'),
            description: {
                text: window.i18n.__('Catégorie du service'),
                subtext: window.i18n.__('Visibles dans Catalogue > Catégories'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Smart-tags'),
            description: {
                text: window.i18n.__('Liste de smart-tags'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
                subtext: window.i18n.__('À séparer par une virgule'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Propriétaire'),
            description: {
                text: window.i18n.__('Propriétaire du service'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__(
                "Si ce champ n'est pas renseigné alors le nom d’utilisateur qui initie l’import sera ajouté",
            ),
            value: {
                text: window.i18n.__('Nom complet du propriétaire du service importé'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Le service est utilisable dans le timetracking'),
            description: {
                text: window.i18n.__('Utilisable sur le timetracking. Valeurs possibles: Y/N'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('"Y" pour oui ou "N" pour non'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Prix de référence HT'),
            description: {
                text: window.i18n.__('Prix de référence hors taxe du service'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique (2 décimales)'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Taxe'),
            description: {
                text: window.i18n.__('Taux de taxe associé au service'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Taux de taxe parmi la liste existante'),
            },
            valueFrom: {
                source: 'taxes',
                modalName: window.i18n.__('Afficher toutes les taxes'),
                maxDisplay: 6,
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Prix achat HT'),
            description: {
                text: window.i18n.__("Prix d'achat hors taxe du service"),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique (2 décimales)'),
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Code comptable vente'),
            description: {
                text: window.i18n.__('Code comptable de vente à associer au service'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Code comptable parmi la liste existante'),
            },
            valueFrom: {
                source: 'sellAccountingCodes',
                modalName: window.i18n.__('Afficher toutes les valeurs de codes comptables vente'),
                maxDisplay: 3,
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Code comptable achat'),
            description: {
                text: window.i18n.__("Code compte d'achat à associer au service"),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Code comptable parmi la liste existante'),
            },
            valueFrom: {
                source: 'purchaseAccountingCodes',
                modalName: window.i18n.__('Afficher toutes les valeurs de codes comptables achat'),
                maxDisplay: 3,
            },
        },
        {
            category: 'service',
            label: window.i18n.__('Archivé'),
            description: {
                text: window.i18n.__('Archiver ou non le service'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('"Y" pour oui ou "N" pour non'),
            },
        },
    ],
};
